import React from "react";
import { AppBar, Dialog, IconButton, Toolbar, Typography, makeStyles } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CloseIcon from "@material-ui/icons/Close";
import LoopIcon from "@material-ui/icons/Loop";

const useStyles = makeStyles((theme) => ({
  fullScreenRoot: {
    backgroundColor: "#F8FAFC",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
  appBar: {
    backgroundColor: "#FFFFFF",
    color: "#111827",
    boxShadow: "0 1px 4px rgba(15, 23, 42, 0.15)",
  },
  toolbar: {
    minHeight: "64px",
  },
  closeButton: {
    marginRight: "8px",
  },
  fileName: {
    flex: 1,
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    paddingRight: "12px",
  },
  imageContainer: {
    flex: 1,
    width: "100%",
    boxSizing: "border-box",
    padding: "24px 5%",
    overflowY: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      padding: "12px 16px",
    },
  },
  fullImage: {
    width: "100%",
    height: "auto",
    maxHeight: "calc(100vh - 130px)",
    objectFit: "contain",
    display: "block",
  },
  deleteButton: {
    color: "#D92D20",
    marginLeft: "6px",
    padding: "6px",
    "& .MuiSvgIcon-root": {
      fontSize: "32px",
    },
    "&:hover": {
      backgroundColor: "rgba(217, 45, 32, 0.08)",
      color: "#B42318",
    },
  },
  retakeButton: {
    color: theme.palette.primary.main,
    marginLeft: "6px",
    padding: "6px",
    "& .MuiSvgIcon-root": {
      fontSize: "32px",
    },
    "&:hover": {
      backgroundColor: "rgba(23, 119, 57, 0.08)",
      color: "#229C27",
    },
  },
}));

type DocumentImageViewerProps = {
  open: boolean;
  onClose: () => void;
  imageUrl?: string;
  fileName?: string;
  alt?: string;
  allowDelete?: boolean;
  onDelete?: () => void;
  onRetake?: () => void;
};

const DocumentImageViewer: React.FC<DocumentImageViewerProps> = ({
  open,
  onClose,
  imageUrl = "",
  fileName = "Archivo",
  alt = "Documento",
  allowDelete = false,
  onDelete,
  onRetake,
}) => {
  const classes = useStyles();

  const handleDelete = () => {
    onDelete?.();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullScreen fullWidth maxWidth="xl">
      <div className={classes.fullScreenRoot}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <IconButton aria-label="cerrar" onClick={onClose} className={classes.closeButton}>
              <CloseIcon />
            </IconButton>
            <Typography variant="subtitle1" className={classes.fileName} title={fileName}>
              {fileName}
            </Typography>
            {onRetake && (
              <IconButton
                aria-label="volver a tomar foto"
                onClick={onRetake}
                className={classes.retakeButton}
              >
                <LoopIcon />
              </IconButton>
            )}
            {allowDelete && (
              <IconButton
                aria-label="eliminar imagen"
                onClick={handleDelete}
                className={classes.deleteButton}
              >
                <DeleteOutlineIcon />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>

        <div className={classes.imageContainer}>
          <img src={imageUrl} alt={alt} className={classes.fullImage} />
        </div>
      </div>
    </Dialog>
  );
};

export default DocumentImageViewer;
